import React from 'react';
import PropTypes from 'prop-types';

const ModalBody = ({ children }) => (
  <div className="ds-modal-body">
    {children}
  </div>
);

ModalBody.defaultProps = {
  children: null,
};

ModalBody.propTypes = {
  children: PropTypes.node,
};

export default ModalBody;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/FormSwiftModal/ModalBody.jsx